import React from "react";

const WithPermissions = ({ children }) => {
  return <>{children}</>;
};

export default WithPermissions;
